<div class="ctnr d-flex justify-content-center align-items-center p-3">
  <div class="alert-box alert alert-danger p-4" role="alert">
      <h4 class="alert-heading fw-bold">{{ errorObj.name }}</h4>
      <p>{{ errorDescription }}</p>
      <div class="d-flex justify-content-end">
        <button class="btn btn-danger" (click)="navigateToLogin()" *ngIf="errorBtnText.length > 1 ">{{ errorBtnText }}</button>
      </div>
  </div>
</div>